import { BrowserRouter, Routes, Route } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";

import { auth } from "./firebase";
import { ProtectedRoute } from "./components/protectedRoute";
import { AdminProtectedRoute } from "./components/AdminProtectedRoute";
import { ModeratorProtectedRoute } from "./components/ModeratorProtectedRoute";
import { HofdienstProtectedRoute } from "./components/HofdienstProtectedRoute";
import { Login } from "./pages/login/Login";
import { AdminPanel } from "./adm/AdminPanel";
import { UmleitungAdd } from "./adm/UmleitungAdd";
import { UmleitungenDelete } from "./adm/UmleitungenDelete";

// import { SchulMeineDB } from "./pages/handys_screens/meine_db/SchulMeineDB";
// import { Plans } from "./pages/plans_screen/Plans";
import { PlansFire } from "./pages/plans_screen/PlansFire";
import { PlansChoice } from "./pages/plans_screen/PlansChoice";
import LayoutAppBar from "./components/LayoutAppBar";
// import InVorbereitung from "./pages/InVorbereitung";
// import { StopsIndicator } from "./pages/handys_screens/stops_indicator/StopsIndicator";
import { BusParkingGame } from "./pages/spielchen/BusParkingGame"
import { Umleitungen } from "./pages/umleitungen/Umleitungen";
import { UmleitungenPager } from "./pages/umleitungen/UmleitungenPager";
// import { BvhApp } from "./pages/handys_screens/bvh/BvhApp";
import { Helmet } from "react-helmet";
import BetrInfos from "./pages/betrinfo/BetrInfos";
// import { EcoApp } from "./pages/handys_screens/eco_app/EcoApp";
// import { LapId } from "./pages/handys_screens/lap_id/LapId";
// import { EviApp } from "./pages/handys_screens/evi_app/EviApp";
// import { TeamsApp } from "./pages/handys_screens/teams_app/TeamsApp";
// import { OutlookApp } from "./pages/handys_screens/outlook_app/OutlookApp"
import ScrollRestoration from "./components/ScrollRestoration";
import { QRCode } from "./adm/QRCode";
import { AdmPlans } from "./adm/AdmPlans";
import "./setupAdmin"; // For initial admin setup
import { useVersionCheck } from "./utils/useVersionCheck";

import "./App.css";
import { useEffect, useState } from "react";
import AddUser from "./adm/AddUser";
import AddInfo from "./adm/AddInfo";
import NewAccountAsk from "./pages/login/NewAccountAsk";
import { Registration } from "./pages/login/Registration";
import { PasswordReset } from "./pages/login/PasswordReset";
import { LandingQRCode } from "./pages/LandingQRCode";
import InfoGigLandingPage, { StartPoster } from "./pages/StartPoster";
import UsersList from "./adm/UsersList";
import ChroniclesMain from "./pages/public_pages/chronicles/ChroniclesMain";
import ChronicleBeginning from "./pages/public_pages/chronicles/ChronicleBeginning";
import ChronicleReform from "./pages/public_pages/chronicles/ChronicleReform";
import ChronicleExpansion from "./pages/public_pages/chronicles/ChronicleExpansion";
import ChronicleModernization from "./pages/public_pages/chronicles/ChronicleModernization";
import ChroniclePeople from "./pages/public_pages/chronicles/ChroniclePeople";
import ManualTelematik from "./pages/public_pages/user_manuals/ManualTelematik";
import UserManualsMain from "./pages/public_pages/user_manuals/UserManualsMain";
import { ManualLapId } from "./pages/public_pages/user_manuals/ManualLapId";
// import { UbkApp } from "./pages/handys_screens/ubk/UbkApp";
import DriverPl from "./pages/marketing/DriverPl";
import Driving_Position from "./pages/public_pages/user_manuals/Driving_Position";
import Bus_Stop_Trainning from "./pages/public_pages/user_manuals/Bus_Stop_Trainning";
import Door_System from "./pages/public_pages/user_manuals/Door_System";
import Bus_Park from "./pages/bus_park/Bus_Park";
import Bus_Park_Print from "./pages/bus_park/Bus_Park_Print";
import Add_Bus_Park from "./pages/bus_park/Add_Bus_Park";
import HomePage from "./pages/home_page/HomePage";
import AdmHandysSchule from "./adm/AdmHandysSchule";
import HandysSchuleCollections from "./pages/handys_school/HandysSchuleCollections";



function App() {
  const [user, setUser] = useState(null);
  const [isFetching, setIsFetching] = useState(true);

  // Global version check - will automatically reload app if version changes
  useVersionCheck(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
        setIsFetching(false);
        return;
      }

      setUser(null);
      setIsFetching(false);
    });
    return () => unsubscribe();
  }, []);


  // MONETAG ADS SCRIPT
  // useEffect(() => {
  //   const script = document.createElement('script');
  //   script.dataset.zone = '10142265';
  //   script.src = 'https://forfrogadiertor.com/tag.min.js';
  //   document.body.appendChild(script);
  //   return () => {
  //     document.body.removeChild(script);
  //   };
  // }, []);

  //   useEffect(() => {
  //   const script = document.createElement('script');
  //   script.dataset.zone = '10146343';
  //   script.src = 'https://otieu.com/tag.min.js';
  //   document.body.appendChild(script);
  //   return () => {
  //     document.body.removeChild(script);
  //   };
  // }, []);

  //  useEffect(() => {
  //     const script = document.createElement('script');
  //     script.dataset.zone = '10142265';
  //     script.src = 'https://forfrogadiertor.com/tag.min.js';
  //     script.async = true;
  //     document.body.appendChild(script);
  //     return () => {
  //       document.body.removeChild(script);
  //     };
  //   }, []);

  // END MONETAG ADS SCRIPT



  if (isFetching) {
    return <h2>Loading...</h2>;
  }

  return (
    <>
      <Helmet>
        <title>InfoGig App</title>
        <meta name="description" content="InfoGig App für DB Regio Bus Mitte; alle wichtige informationen für Fahrer." />
        <meta name="robots" content="noindex, nofollow" />
        <link rel="icon" type="image/png" href="/InfoGig.png" />
        <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2742135818753184"
          crossorigin="anonymous"></script>
      </Helmet>
      <BrowserRouter>
        <ScrollRestoration />
        <Routes>
          <Route index path="/" element={
            <>
              <LayoutAppBar />
              <Login user={user} />
            </>
          } >
          </Route>
          <Route path="/start" element={<StartPoster />} />
          <Route path="/qr-landing" element={<LandingQRCode />} />
          <Route path="/new-account-ask" element={<NewAccountAsk />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/password-reset" element={<PasswordReset />} />

          <Route path="/driver" element={<DriverPl />} />
          {/* <Route path="/stops_indicator_adv" element={<StopsIndicator />} /> */}

          {/* Main Menu */}
          <Route
            path="/home"
            element={
              <ProtectedRoute user={user}>
                <LayoutAppBar />
                <HomePage />
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/plans"
            element={
              <ProtectedRoute user={user}>
                <LayoutAppBar />
                <Plans />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="/plansfire"
            element={
              <ProtectedRoute user={user}>
                <LayoutAppBar />
                <PlansFire />
              </ProtectedRoute>
            }
          />

          <Route
            path="/plans_choice"
            element={
              <ProtectedRoute user={user}>
                <LayoutAppBar />
                <PlansChoice />
              </ProtectedRoute>
            }
          />

          <Route
            path="/betrinfos"
            element={
              <ProtectedRoute user={user}>
                <LayoutAppBar />
                <BetrInfos />
              </ProtectedRoute>
            }
          />

          <Route
            path="/umleitungen"
            element={
              <ProtectedRoute user={user}>
                <LayoutAppBar />
                <Umleitungen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/umleitungen_pager"
            element={
              <ProtectedRoute user={user}>
                <LayoutAppBar />
                <UmleitungenPager />
              </ProtectedRoute>
            }
          />

          {/* Admin Routes */}
          <Route
            path="/adm_set_role"
            element={
              <AdminProtectedRoute user={user}>
                <LayoutAppBar />
                <AdminPanel />
                {/* <UsersList /> */}
              </AdminProtectedRoute>
            }
          />
          
          {/* <Route
            path="/adm/add_user"
            element={
              <ModeratorProtectedRoute user={user}>
                <LayoutAppBar />
                <AddUser />
                <UsersList />
              </ModeratorProtectedRoute>
            }
          /> */}

          {/* <Route
            path="/adm/users_list"
            element={
              <ModeratorProtectedRoute user={user}>
                <LayoutAppBar />
                <UsersList />
              </ModeratorProtectedRoute>
            }
          /> */}

          <Route
            path="/adm/umleitung"
            element={
              <ModeratorProtectedRoute user={user}>
                <LayoutAppBar />
                <UmleitungAdd />
              </ModeratorProtectedRoute>
            }
          />
          <Route
            path="/adm/umleitung_del"
            element={
              <ModeratorProtectedRoute user={user}>
                <LayoutAppBar />
                <UmleitungenDelete />
              </ModeratorProtectedRoute>
            }
          />
          <Route
            path="/adm/add_plans"
            element={
              <ModeratorProtectedRoute user={user}>
                <LayoutAppBar />
                <AdmPlans />
              </ModeratorProtectedRoute>
            }
          />
          
          <Route
            path="/adm/qr"
            element={
              <ModeratorProtectedRoute user={user}>
                <LayoutAppBar />
                <QRCode />
              </ModeratorProtectedRoute>
            }
          />
          <Route
            path="/adm/bus_park"
            element={
              <HofdienstProtectedRoute user={user}>
                <LayoutAppBar />
                <Bus_Park />
                {/* <UsersList /> */}
              </HofdienstProtectedRoute>
            }
          />
          <Route
            path="/bus_park_print"
            element={
              <ProtectedRoute user={user}>
                <Bus_Park_Print />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adm/bus_park_add"
            element={
              <HofdienstProtectedRoute user={user}>
                <LayoutAppBar />
                <Add_Bus_Park />
              </HofdienstProtectedRoute>
            }
          />

{/* Handy Schulung Admin */}
          <Route
            path="/adm/handys_schule"
            element={
              <ModeratorProtectedRoute user={user}>
                <LayoutAppBar />
                <AdmHandysSchule />
              </ModeratorProtectedRoute>
            }
          />

{/* HANDYS_SCHOOL */}
          <Route
            path="/handys_school"
            element={
              <ProtectedRoute user={user}>
                <LayoutAppBar />
                <HandysSchuleCollections />
              </ProtectedRoute>
            }
          />
          <Route
            path="/handys_school/:collectionId"
            element={
              <ProtectedRoute user={user}>
                <LayoutAppBar />
                <HandysSchuleCollections />
              </ProtectedRoute>
            }
          />

{/* One static site with add for Stops Indicator */}
          {/* <Route
            path="/stops_indicator"
            element={
              <ProtectedRoute user={user}>
                <LayoutAppBar />
                <StopsIndicator />
              </ProtectedRoute>
            }
          /> */}
{/* END OF One static site with add for Stops Indicator */}


          {/* Schulungs Apps Handys */}
          {/* <Route
            path="/schul_meine_db"
            element={
              <ProtectedRoute user={user}>
                <LayoutAppBar />
                <SchulMeineDB />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bvh_app"
            element={
              <ProtectedRoute user={user}>
                <LayoutAppBar />
                <BvhApp />
              </ProtectedRoute>
            }
          />
          <Route
            path="/eco_app"
            element={
              <ProtectedRoute user={user}>
                <LayoutAppBar />
                <EcoApp />
              </ProtectedRoute>
            }
          />
          <Route
            path="/lap_id"
            element={
              <ProtectedRoute user={user}>
                <LayoutAppBar />
                <LapId />
              </ProtectedRoute>
            }
          />

          <Route
            path="/evi_app"
            element={
              <ProtectedRoute user={user}>
                <LayoutAppBar />
                <EviApp />
              </ProtectedRoute>
            }
          />

          <Route
            path="/teams_app"
            element={
              <ProtectedRoute user={user}>
                <LayoutAppBar />
                <TeamsApp />
              </ProtectedRoute>
            }
          />

          <Route
            path="/outlook_app"
            element={
              <ProtectedRoute user={user}>
                <LayoutAppBar />
                <OutlookApp />
              </ProtectedRoute>
            }
          />

          <Route
            path="/stops_indicator"
            element={
              <ProtectedRoute user={user}>
                <LayoutAppBar />
                <StopsIndicator />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ubk_app"
            element={
              <ProtectedRoute user={user}>
                <LayoutAppBar />
                <UbkApp />
              </ProtectedRoute>
            }
          /> */}


          <Route
            path="/bus_parking_game"
            element={
              <ProtectedRoute user={user}>
                <LayoutAppBar />
                <BusParkingGame />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adm/umleitung/edit/:id"
            element={
              <ModeratorProtectedRoute user={user}>
                <LayoutAppBar />
                <UmleitungAdd />
              </ModeratorProtectedRoute>
            }
          />
          <Route
            path="/adm/umleitung/add"
            element={
              <ModeratorProtectedRoute user={user}>
                <LayoutAppBar />
                <UmleitungAdd />
              </ModeratorProtectedRoute>
            }
          />

          <Route path="/adm/umleitungen" element={
            <ModeratorProtectedRoute user={user}>
              <LayoutAppBar />
              <UmleitungenDelete />
            </ModeratorProtectedRoute>
          } />

          <Route path="/adm/addinfo" element={
            <ModeratorProtectedRoute user={user}>
              <LayoutAppBar />
              <AddInfo />
            </ModeratorProtectedRoute>
          } />

          {/* Chronicles Routes */}
          <Route
            path="/chronicles"
            element={
              <>
                <LayoutAppBar />
                <ChroniclesMain />
              </>
            }
          />
          <Route
            path="/chronicles/beginning"
            element={
              <>
                <LayoutAppBar />
                <ChronicleBeginning />
              </>
            }
          />
          <Route
            path="/chronicles/reform"
            element={
              <>
                <LayoutAppBar />
                <ChronicleReform />
              </>
            }
          />
          <Route
            path="/chronicles/expansion"
            element={
              <>
                <LayoutAppBar />
                <ChronicleExpansion />
              </>
            }
          />
          <Route
            path="/chronicles/modernization"
            element={
              <>
                <LayoutAppBar />
                <ChronicleModernization />
              </>
            }
          />
          <Route
            path="/chronicles/people"
            element={
              <>
                <LayoutAppBar />
                <ChroniclePeople />
              </>
            }
          />

          {/* User Manuals Main */}
          <Route
            path="/user_manuals"
            element={
              <>
                <LayoutAppBar />
                <UserManualsMain />
              </>
            }
          />
          <Route
            path="/user_manuals/telematik"
            element={
              <>
                <LayoutAppBar />
                <ManualTelematik />
              </>
            }
          />
          <Route
            path="/user_manuals/manual_lapid"
            element={
              <>
                <LayoutAppBar />
                <ManualLapId />
              </>
            }
          />
          <Route
            path="/user_manuals/driving_position"
            element={
              <>
                <LayoutAppBar />
                <Driving_Position />
              </>
            }
          />
          <Route
            path="/user_manuals/bus_stop_trainning"
            element={
              <>
                <LayoutAppBar />
                <Bus_Stop_Trainning />
              </>
            }
          />
          <Route
            path="/user_manuals/door_system"
            element={
              <>
                <LayoutAppBar />
                <Door_System />
              </>
            }
          />
          {/* ...rest of existing routes... */}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;